var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "search-widget" } }, [
    _c(
      "div",
      {
        staticClass: "ui fluid icon inverted input",
        attrs: { id: "search-term-box" }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.terms,
              expression: "terms"
            }
          ],
          attrs: {
            tabindex: "1",
            type: "text",
            placeholder: "Search by project name, topic..."
          },
          domProps: { value: _vm.terms },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.clearSearchBox.apply(null, arguments)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.terms = $event.target.value
            }
          }
        }),
        !_vm.terms ? _c("i", { staticClass: "search icon" }) : _vm._e(),
        _vm.terms
          ? _c("i", {
              staticClass: "remove link icon",
              on: { click: _vm.clearSearchBox }
            })
          : _vm._e()
      ]
    ),
    _vm.addressSearchResults.length +
    _vm.results.length +
    _vm.tagresults.length +
    _vm.filterTags.size
      ? _c("div", { attrs: { id: "search-results" } }, [
          _c(
            "div",
            { staticClass: "ui relaxed list" },
            [
              _vm.terms && _vm.tagresults.length + _vm.filterTags.size
                ? _c("div", { staticClass: "search-category" }, [
                    _c("p", [_vm._v("TAGS")])
                  ])
                : _vm._e(),
              _vm._l(_vm.tagsActiveOrMatchingSearch, function(tag) {
                return _c(
                  "div",
                  {
                    key: _vm.filterKey + tag,
                    staticClass: "tiny pink ui button",
                    class: { basic: !_vm.filterTags.has(tag) },
                    attrs: { id: "search-tags" },
                    on: {
                      click: function($event) {
                        return _vm.clickedSearchTag(tag)
                      }
                    }
                  },
                  [_vm._v(_vm._s(tag))]
                )
              }),
              _vm.addressSearchResults.length
                ? _c("div", { staticClass: "search-category" }, [
                    _c("p", [_vm._v("ADDRESSES")])
                  ])
                : _vm._e(),
              _vm._l(_vm.addressSearchResults, function(address) {
                return [
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          return _vm.clickedAddress(address)
                        },
                        mouseover: function($event) {
                          return _vm.hoverAddress(address)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "search-item address-item",
                          class: { red: address.red == true }
                        },
                        [_c("h4", [_vm._v(_vm._s(address.place_name))])]
                      )
                    ]
                  )
                ]
              }),
              _vm.results.length
                ? _c("div", { staticClass: "search-category" }, [
                    _c("p", [_vm._v("PROJECTS")])
                  ])
                : _vm._e(),
              _vm._l(_vm.results, function(result) {
                return [
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          return _vm.clickedSearch(result.id)
                        },
                        mouseover: function($event) {
                          return _vm.hoverSearch(result.id)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "search-item" }, [
                        _c("h4", [_vm._v(_vm._s(result.name))])
                      ])
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73710788", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73710788","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchWidget.vue
// module id = null
// module chunks = 